/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetCaseUserBarItemsResponseJson } from './get-case-user-bar-items-response-json';
import { GetCasesResult } from '../results/get-cases-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { CaseUserBarItemDto } from '../models/case-user-bar-item-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetCaseUserBarItemsResponse extends ResponseWithErrorGeneric<GetCaseUserBarItemsResponseJson, GetCasesResult> implements IResponseWithErrorGeneric<GetCasesResult> {
  public cases: CaseUserBarItemDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetCaseUserBarItemsResponse>) {
      super(response, GetCasesResult.Error);
  
      if (this.result !== GetCasesResult.Success) {
        return;
      }
  
      this.cases = this.body.cases ? this.body.cases.map(c => new CaseUserBarItemDto(c)) : [];
    }
  //</custom-body>
}
